import React from 'react';
import FilterTable from './filterTable';
import { WebViewerServersTableColumnCaptions } from './tableColumnCaptions';
import { complexColumn, jsonColumn } from './tableUtils';

const WebViewerServerHistoryTable = (props) => {
  const columns = [{
      dataField: 'eventDateTime',
      text: 'Event time',
      sort: true,
      filter_: { type: 'datetime' },
    }, {
      dataField: 'eventName',
      text: 'Event name',
      sort: true,
      filter_: { type: 'text' },
    },
    {
      dataField: 'previous',
      text: 'Previous values',
      filter_: { type: 'text' },
    }, 
    {
      dataField: 'user.login',
      text: 'User',
      sort: true,
      filter_: { type: 'text' },
    }, {
      dataField: 'info',
      text: 'Info',
      sort: true,
      filter_: { type: 'text' }
  }];

  const defaultSorted = [{
    dataField: 'eventDateTime',
    order: 'desc'
  }];

  return (
    <FilterTable
      {...props}
      objectName="webViewerServersHistory"
      data={props.history.map(histrec => ({
        ...histrec,
        previous: jsonColumn(histrec.previousValues, WebViewerServersTableColumnCaptions),
        info: complexColumn(histrec, [{
          fields: 'device.key',
          label: 'Device key'
        }])
      }))}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no web viewer server history records"
    />
  );
};

export default WebViewerServerHistoryTable;


// WEBPACK FOOTER //
// ./src/components/webViewerServerHistoryTable.js